import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AgencyService from "services/AgencyService";
import { formatValidationErrors } from "utils/ArrayUtils";

export const initialState = {
  list: [],
  fetching: false,
  creating: false,
  updating: false,
  deleting: false,
  errorMessages: [],
  showMessage: false,
  showEditForm: false,
  showNewForm: false,
};

export const fetchAgencies = createAsyncThunk(
  "/fetchAgencies",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyService.fetch();
      var code = response.code;
      return {
        code: code,
        agencies: response.data,
      };
    } catch (err) {
      let code = err.response?.data.code;
      let response = err.response;
      return rejectWithValue({
        code: code,
        errorMessages: response?.data?.message || "Error",
      });
    }
  }
);

export const createAgency = createAsyncThunk(
  "/createAgency",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyService.create(data);
      const code = response.original.code;
      return {
        code: code,
        agencies: response.original.data,
      };
    } catch (err) {
      return rejectWithValue(
        { code: err.response.status, error: err.response?.data.errors } || {
          error: "Error creating a agency",
        }
      );
    }
  }
);

export const updateAgency = createAsyncThunk(
  "/updateAgency",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AgencyService.update(data);
      const code = response.original.code;
      return {
        code: code,
        agencies: response.original.data,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const deleteAgency = createAsyncThunk(
  "/deleteAgency",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AgencyService.delete(id);
      const code = response.original.code;
      return {
        code: code,
        agencies: response.original.data,
      };
    } catch (err) {
      return rejectWithValue({ error: "Error deleting a agency" });
    }
  }
);

export const agencySlice = createSlice({
  name: "agencies",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.fetching = !state.fetching;
    },
    toggleAgencyEditForm: (state) => {
      state.showEditForm = !state.showEditForm;
    },
    toggleAgencyNewForm: (state) => {
      state.showNewForm = !state.showNewForm;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgencies.pending, (state) => {
        state.fetching = true;
      })
      .addCase(fetchAgencies.fulfilled, (state, action) => {
        state.fetching = false;
        state.list = action.payload.agencies;
      })
      .addCase(fetchAgencies.rejected, (state, action) => {
        state.fetching = false;
      })
      .addCase(createAgency.pending, (state) => {
        state.creating = true;
      })
      .addCase(createAgency.fulfilled, (state, action) => {
        state.creating = false;
        state.list = action.payload.agencies;
        state.showNewForm = !state.showNewForm;
      })
      .addCase(createAgency.rejected, (state, action) => {
        if (action.payload.code == 422) {
          state.errorMessages = formatValidationErrors(action.payload.error);
        } else {
          // state.errorMessages = action.payload.error;
        }
        state.creating = false;
      })
      .addCase(updateAgency.pending, (state, action) => {
        state.updating = true;
      })
      .addCase(updateAgency.fulfilled, (state, action) => {
        state.updating = false;
        state.list = action.payload.agencies;
        state.showEditForm = !state.showEditForm;
      })
      .addCase(updateAgency.rejected, (state, action) => {
        state.errorMessages = action.payload;
        state.updating = false;
      })
      .addCase(deleteAgency.pending, (state, action) => {
        state.deleting = true;
      })
      .addCase(deleteAgency.fulfilled, (state, action) => {
        state.deleting = false;
        state.list = action.payload.agencies;
      })
      .addCase(deleteAgency.rejected, (state, action) => {
        state.deleting = false;
      });
  },
});

export const { showLoading, toggleAgencyEditForm, toggleAgencyNewForm } =
  agencySlice.actions;

export default agencySlice.reducer;
